import { UIHeading5 } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as styles from './ComparisonNotificationContainer.css';
import { trackClickPopup, trackPopupLimit } from './tracking';
import { ClearComparisonNotificationType } from '../../actions/comparison/comparisonNotification';
import { ComparisonNotification } from '../../components/ComparisonNotification';
import { NOTIFICATION_EXPIRATION_DELAY } from '../../constants/offersComparison';
import { getOffersComparisonNotification } from '../../selectors/offersComparison/offersComparisonNotification';
import { EComparisonNotificationCategory, IComparisonNotification } from '../../types/comparisonNotification';

const ComparisonNotificationContainer = () => {
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null);
  const dispatch = useDispatch();
  const notification = useSelector(getOffersComparisonNotification) as IComparisonNotification;

  const isLimitNotification = React.useMemo(
    () => notification?.category === EComparisonNotificationCategory.Limit || false,
    [notification],
  );

  const clearNotificationTimeout = React.useCallback(() => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, []);

  const startNotificationTimeout = React.useCallback(() => {
    clearNotificationTimeout();
    timeoutRef.current = setTimeout(() => {
      dispatch({ type: ClearComparisonNotificationType });
      timeoutRef.current = null;
    }, NOTIFICATION_EXPIRATION_DELAY);
  }, [clearNotificationTimeout, dispatch]);

  React.useEffect(() => {
    if (isLimitNotification) {
      trackPopupLimit();
    }

    startNotificationTimeout();

    return clearNotificationTimeout;
  }, [notification, isLimitNotification, startNotificationTimeout, clearNotificationTimeout]);

  const handleLinkClick = React.useCallback(() => {
    trackClickPopup({ category: notification?.category });
    startNotificationTimeout();
  }, [notification?.category, startNotificationTimeout]);

  const handleClose = React.useCallback(() => {
    dispatch({
      type: ClearComparisonNotificationType,
    });
  }, [dispatch]);

  const handleMouseEnter = clearNotificationTimeout;

  const control = notification?.url ? (
    <UIHeading5 color="text-inverted-default">
      <a href={notification.url} className={styles['link']} onClick={handleLinkClick} target="_blank" rel="noreferrer">
        Перейти
      </a>
    </UIHeading5>
  ) : (
    <UIHeading5 color="text-inverted-default">
      <button onClick={handleClose} className={styles['button']}>
        Понятно
      </button>
    </UIHeading5>
  );

  if (!notification || notification.text.length === 0) {
    return null;
  }

  return <ComparisonNotification control={control} text={notification.text} onMouseEnter={handleMouseEnter} />;
};

// eslint-disable-next-line import-x/no-default-export
export default ComparisonNotificationContainer;
